import React from 'react';
import { FileText, Upload, Send } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import QuestionList from '../shared/QuestionList';

const MyQuestions = () => {
  const navigate = useNavigate();

  // Custom actions for content generator workflow
  const customActions = [
    {
      label: 'Create Question',
      icon: <FileText className="w-4 h-4" />,
      onClick: () => navigate('/content-generator/create-question'),
      className: 'px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700'
    },
    {
      label: 'Bulk Upload',
      icon: <Upload className="w-4 h-4" />,
      onClick: () => navigate('/content-generator/bulk-upload'),
      className: 'px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700'
    }
  ];

  // Workflow actions for draft questions
  const workflowActions = [
    {
      title: 'Submit for Review',
      icon: <Send className="w-4 h-4" />,
      onClick: (question) => handleSubmitForReview(question),
      className: 'text-gray-400 hover:text-blue-600'
    }
  ];

  const handleSubmitForReview = async (question) => {
    try {
      // TODO: Implement submit for review API call
      console.log('Submitting question for review:', question.id);
      // await superAdminAPI.submitDraftQuestionForReview(question.id);
      // showSuccessToast('Question submitted for review');
      // Reload questions list
    } catch (error) {
      console.error('Error submitting question for review:', error);
      // showErrorToast(error);
    }
  };

  return (
    <QuestionList
      isDraft={true}
      title="My Draft Questions"
      apiEndpoint="/api/super-admin/content-generator/my-questions"
      allowCreate={false} // We use custom actions instead
      allowBulkUpload={false} // We use custom actions instead
      customActions={customActions}
      workflowActions={workflowActions}
    />
  );
};

export default MyQuestions;
